<template>

    <div v-if="list.length" class="banner">
        <a class="left block" :style="bannerStyle" :href="tplGetRecommendHref(list[activeIndex])" :target="tplGetRecommendTarget(list[activeIndex])"></a>

        <div class="right">
            <ul>
                <li v-for="(item, index) in list" :class="{active: activeIndex === index}"
                    @mouseover="showListPic(index)">
                    <a :href="tplGetRecommendHref(item)" :target="tplGetRecommendTarget(item)">{{item.title2 || item.title}}</a>
                </li>
            </ul>

            <div class="back-image" :style="bannerStyle"></div>
        </div>
    </div>

</template>

<script>
import request from "Services/axios";
import Utils from "@/utils/utils";

export default {

    data() {
        return {
            list: [],

            activeIndex: 0
        }
    },

    computed: {
        bannerStyle() {
            return {backgroundImage: 'url("' + this.list[this.activeIndex].covers + '")'}
        }
    },

    created() {
        request({
            url: '/api/web/article/getRecommends.htm?name=PAGE_HOME_TOP&pageSize=30',
            method: 'get',
        }).then((res) => {
            let oriData = res.data;

            this.list = oriData.data.articleList || {};

            this.autoPlay();
        })
    },

    methods: {
        tplGetRecommendHref(item) {
            return Utils.getRecommendHref(item)
        },

        tplGetRecommendTarget(item) {
            return Utils.getRecommendTarget(item)
        },

        showListPic(index) {
            this.activeIndex = index;
        },

        autoPlay() {
            const next = () => {
                this.activeIndex = this.activeIndex === this.list.length - 1 ? 0 : this.activeIndex + 1;
            }

            setInterval(next, 3000);
        }
    }

}
</script>

<style lang="less" scoped>

.banner {
    height: 418px;

    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;

    .left {
        width: 755px;
        height: 418px;
        overflow: hidden;
        position: relative;

        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .right {
        background: rgba(0, 0, 0, 0.56);
        width: 440px;
        font-size: 20px;
        position: relative;
        overflow: hidden;

        ul {
            position: relative;
            z-index: 1;
            padding-top: 10px;
            padding-left: 24px;

            li {
                padding-top: 24px;
                color: #fff;
                font-family: Helvetica;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                opacity: 0.8;

                transition: transform .5s;

            }

            li.active {
                /*text-decoration: underline;*/
                color: #f00;
                transform: scale(1.05);
                transition: transform .5s;
            }

        }
    }


    .back-image {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
        filter: blur(20px);
    }
}

</style>
